import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrimaryInputComponent} from './primary-input/primary-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RadioButtonComponent} from './radio-button/radio-button.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [PrimaryInputComponent, RadioButtonComponent],
  exports: [PrimaryInputComponent, RadioButtonComponent],
  providers: []
})
export class TextInputsModule {
}
